import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_faq_box = _resolveComponent("faq-box")
  const _component_performance_marketing_section = _resolveComponent("performance-marketing-section")

  return (_openBlock(), _createBlock(_component_performance_marketing_section, { title: "Questions & Answers" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.questions, (question) => {
          return (_openBlock(), _createBlock(_component_faq_box, {
            key: question.title,
            nested: "",
            title: question.title,
            description: question.description,
            "is-initially-collapsed": ""
          }, null, 8 /* PROPS */, ["title", "description"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}